<script>
import heroImage from '@/assets/foto/tahdik5.jpg';

export default {
  name: "Hero-Comp",
  data() {
    return {
      heroImage
    };
  }
};
</script>

<template>
  <div class="relative h-screen w-full flex flex-col justify-center items-center text-center text-white"
       :style="{ backgroundImage: `url(${heroImage})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover' }">

    <!-- Overlay -->
    <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-0"></div>

    <!-- Content -->
    <div class="relative z-1 p-4">
      <h2 class="text-2xl md:text-4xl font-['Vazirmatn',_sans-serif] mb-4" style="direction: rtl;">
        به رستوران <span class="text-orange-500">تهدیگ</span> خوش آمدید
      </h2>
      <div class="font-['Poltawski_Nowy',_sans-serif]">
        <h1 class="text-4xl md:text-6xl font-bold uppercase">
          Welkom bij  <span class="text-orange-500">Tahdik</span> Restaurant
        </h1>
        <p class="text-lg md:text-xl mt-2 uppercase">
          The Crunch of Persia
        </p>
      </div>
      <router-link to="/menu"
                   class="mt-8 inline-block bg-orange-500 text-white text-xl font-bold py-3 px-8 rounded-lg uppercase tracking-wider hover:bg-orange-600 transition-colors duration-300">
        Menu
      </router-link>
      <br>
      <router-link to="/reserveren"
                   class="mt-4 inline-block bg-orange-500 text-white text-xl font-bold py-3 px-8 rounded-lg uppercase tracking-wider hover:bg-orange-600 transition-colors duration-300">
        Reserveren
      </router-link>
    </div>
  </div>
</template>

<style scoped>
/* Scoped styles are no longer needed as all styling is done via Tailwind CSS classes. */
</style>
